import { supabase } from "@/integrations/supabase/client";

export async function setupDemoData() {
  console.log("Setting up demo environment...");
  
  try {
    // Step 1: Create demo users via edge function
    console.log("Creating demo users...");
    const { data: userData, error: userError } = await supabase.functions.invoke(
      'setup-demo-users'
    );
    
    if (userError) {
      console.error("Error creating users:", userError);
      throw userError;
    }
    
    console.log("✓ Demo environment ready!");
    return { success: true, data: userData };
    
  } catch (error) {
    console.error("Failed to setup demo:", error);
    return { success: false, error };
  }
}
